import(/* webpackMode: "eager" */ "/vercel/path0/app/(marketing)/for/students/page.tsx");
